import { describeFields, FieldWidget } from '../common/fields';
import { RoomSchema } from './schemas';

export const ROOM_FIELDS = describeFields(RoomSchema, {
  location: { widget: FieldWidget.Text },
  roomId: {},
  label: {},
});
